import navCss from '../../navigation.module.css'
import firstRocket from '../../../../asserts/rockets/FirstRocket.png'
import secondRocket from '../../../../asserts/rockets/SecondRocket.png'
import thirdRocket from '../../../../asserts/rockets/ThirdRocket.png'
import fourthRocket from '../../../../asserts/rockets/FourthRocket.png'
import fifthRocket from '../../../../asserts/rockets/FifthRocket.png'
import rocket5 from '../../../../asserts/rockets/book_1_active.png'
import rocket6 from '../../../../asserts/rockets/book_2_active.png'
import rocket7 from '../../../../asserts/rockets/book_3_active.png'
import { useRecoilState, useRecoilValue } from 'recoil'
import navigationAtom from '../../navigation.atom'
import useNavigationActions from '../../useNavigationActions'
import sandboxAtom from '../../../Sandbox/sandbox.atom'
import { ReactComponent as PlusIcon } from '../../../../asserts/icons/plus.svg'
import { useNavigate } from 'react-router-dom'
import { useMemo, useState } from 'react'
import { ILevel } from '../../../../types/tasks.types'
import CreateRocketModal from './CreateRocketModal'
import Dropdown from '../../../../shared/Inputs/Dropdown'

export const rocketImages = [
  firstRocket,
  secondRocket,
  thirdRocket,
  fourthRocket,
  fifthRocket,
  rocket5,
  rocket6,
  rocket7,
]
const RocketsNavigation = () => {
  const navigate = useNavigate()
  const { rocket } = useRecoilValue(navigationAtom)
  const { toRocket } = useNavigationActions()
  const [sandboxState] = useRecoilState(sandboxAtom)
  const [createRocketModalOpen, setCreateRocketModalOpen] = useState(false)
  const [selectedLevel, setSelectedLevel] = useState<ILevel['id']>(sandboxState.levels[0].id)

  const levelsOptions = useMemo(() => {
    return sandboxState.levels.map((l) => ({ title: l.name, value: l.id }))
  }, [sandboxState.levels])

  const levelsMap: Record<ILevel['id'], ILevel> = useMemo(() => {
    return sandboxState.levels.reduce((acc, val) => ({ ...acc, [val.id]: val }), {})
  }, [sandboxState.levels])

  const handleCreateRocket = () => {
    setCreateRocketModalOpen(true)
  }

  const renderRockets = () => {
    return sandboxState.sets
      .filter((s) => s.level === selectedLevel)
      .map((set, index) => (
        <div
          onDoubleClick={() => navigate('/rockets/' + set.id)}
          key={set.id}
          data-active={set.id === rocket}
          onClick={() => toRocket(set.id)}
          className={navCss.rocket}
          style={{ backgroundImage: `url("${rocketImages[index % rocketImages.length]}")` }}
        >
          <div className={navCss.rocketLevelTitle}>{levelsMap[set.level]?.name || 'Нет уровня'}</div>
        </div>
      ))
  }

  return (
    <div className={navCss.horizontalScroll} style={{ overflow: 'visible', alignItems: 'center' }}>
      {createRocketModalOpen && <CreateRocketModal onClose={() => setCreateRocketModalOpen(false)} />}
      <div
        className={navCss.plusIcon}
        onClick={handleCreateRocket}
        style={{ marginLeft: '1em', width: '20px', height: '20px' }}
      >
        <PlusIcon width="20px" height="20px" style={{ fill: 'var(--success)' }} />
      </div>
      <Dropdown
        options={levelsOptions}
        style={{ height: '40px' }}
        selectedOption={selectedLevel}
        title="Уровень"
        onSelect={(val) => setSelectedLevel(val)}
      />
      {renderRockets()}
    </div>
  )
}

export default RocketsNavigation
